export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/referral_program_perseus/discount.ed2ca13.svg";